import { useCallback } from "react";
import axiosConfig from "../../axiosConfig";

const useAuthApi = () => {
  const login = useCallback(async (payload) => {
    return axiosConfig.post("/login", payload);
  }, []);

  const register = useCallback(async (payload) => {
    return axiosConfig.post("/register", payload);
  }, []);

  const forgotPassword = useCallback(async (payload) => {
    return axiosConfig.post("/forgot-password", payload);
  }, []);

  return {
    login,
    register,
    forgotPassword,
  };
};

export default useAuthApi;

